var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube2024(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0653 3.64506C20.1909 4.70901 20.2583 5.77881 20.2671 6.84987V8.35177C20.2583 9.42256 20.1909 10.4921 20.0653 11.5558C19.9687 12.2671 19.6915 12.9431 19.2592 13.5213C18.7199 14.0512 17.9909 14.3522 17.2286 14.3598C14.3918 14.5598 10.1331 14.5663 10.1331 14.5663C10.1331 14.5663 4.86406 14.5188 3.24273 14.367C2.41903 14.3565 1.62627 14.0565 1.00793 13.5213C0.575704 12.9431 0.298745 12.2671 0.202602 11.5558C0.0765122 10.4922 0.00885434 9.42258 0 8.35177V6.84987C0.00883448 5.77879 0.0764924 4.70897 0.202602 3.64506C0.298672 2.93397 0.575645 2.25819 1.00793 1.68037C1.54674 1.14979 2.27604 0.848676 3.03853 0.841864C5.87524 0.641865 10.129 0.641846 10.129 0.641846H10.1381C10.1381 0.641846 14.3918 0.641865 17.2286 0.841864C17.991 0.848676 18.7204 1.14979 19.2592 1.68037C19.6915 2.25823 19.9687 2.93396 20.0653 3.64506V3.64506ZM8.04047 10.1743L13.513 7.40247L8.04047 4.61123V10.1743Z",
    fill: "#004B81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube2024);
export default __webpack_public_path__ + "static/media/youtube 2024.4863ee3d.svg";
export { ForwardRef as ReactComponent };